(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
    
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
    
            fetch(this.dataset.url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.innerHTML = recommendations.innerHTML;
                  
                }
                let elms = document.getElementsByClassName( 'splide' );
                  if(elms.length > 0 ){
                    for ( let i = 0, len = elms.length; i < len; i++ ) {
                    new Splide( elms[ i ] ).mount();
                    }
                  }
              })
              .catch(e => {
                console.error(e);
              });
          }
          new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    
        }
      }
    
      customElements.define('product-recommendations', ProductRecommendations);
      

  } catch(e) { console.error(e); }
})();
})();
